module.exports = __webpack_public_path__ + "static/img/2s-info-b5.41539c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/2s-info-b5.jpg
// module id = gr/A
// module chunks = 0